import React, { Component } from 'react';
import { Route, Switch } from "react-router-dom";

import ApplyPage from "./components/pages/ApplyPage";
import LandingPage from "./components/pages/LandingPage";
import ThanksPage from "./components/pages/ThanksPage";

class App extends Component {
  render() {
    return (
      <Switch>
        <Route path="/" exact component={LandingPage} />
        <Route path="/job/:job" exact component={LandingPage} />
        <Route path="/apply" exact component={ApplyPage} />
        <Route path="/apply/:jobId" exact component={ApplyPage} />
        <Route path="/thanks" component={ThanksPage} />
      </Switch>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js